import type { NskResponse } from '~/models/Api';
import { postRequest } from '~/utils/api/api_handler';
import type { DealConstruction } from '~/models/DealConstruction';

const paths = {
  updateSeq: '/vendors/deals/:deal_id/deal_estimations/update_seq'
};

export const updateSeq = async (
  dealEstimations: DealConstruction[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(paths.updateSeq.replace(':deal_id', String(dealId)), {
    dealEstimations
  });
